import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";

import mergeDeep from "../../util/mergeDeep.js";
import redirector from "../../util/redirector.js";
import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";

import * as domainConstants from "../../constants/DomainConstants";
import * as pageConstants from "../../constants/EasterEggConstants";
import * as types from "../../constants/ComponentConstants";

import * as aanvraagActions from "../../actions/aanvraagActions";
import * as layoutActions from "../../actions/layoutActions";
import * as infrastructuurActions from "../../actions/infrastructuurActions";
import showToastr from "../../util/toastr.js";

import AanvraagForm from "./AanvraagForm";
import AanvraagPageHelper from "./AanvraagPageHelper";
import aanvragersFormattedForDropdown from "../../selectors/aanvragersFormattedForDropdown";
import EasterEggHandler from "../common/EasterEggHandler";

class AanvraagPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		// initialize the page's local state
		this.state = {
			aanvraag: { aanvragers: [], contactpersoon1: {}, contactpersoon2: {} },
			type: props.type,
			titleSet: false,
			hasUnsavedChanges: false,
			listOfAanvragers: []
		};

		this.pageHelper = new AanvraagPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.AANVRAAG);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.receiveProps(nextProps);
		this.easterEggHandler.initiateGemeenten(this.props.gemeenten);
		this.easterEggHandler.initiatePostcoden(this.props.postcodes);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}

	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	handleOnChange(event, data) { return this.pageHelper.onChange(event, data); }
	handleOnChangeAanvrager(event, i, data) { return this.pageHelper.onChangeAanvrager(event, i, data); }
	handleOnChangeContactpersoon(event, i, data) { return this.pageHelper.onChangeContactpersoon(event, i, data); }
	handleOnAddAanvrager() { return this.pageHelper.onAddAanvrager(); }
	handleOnRemoveAanvrager(event, i) { return this.pageHelper.onRemoveAanvrager(event, i); }
	handleOnSave(event) { return this.pageHelper.onSave(event); }
	handleOnAddGemandateerde(event, aanvragerIndex) { return this.pageHelper.onAddGemandateerde(event, aanvragerIndex); }
	handleOnRemoveGemandateerde(event, i, aanvragerIndex, errorIndex) { return this.pageHelper.onRemoveGemandateerde(event, i, aanvragerIndex, errorIndex); }
	handleOnChangeGemandateerde(event, i, aanvragerIndex, data) { return this.pageHelper.onChangeGemandateerde(event, i, aanvragerIndex, data); }

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.aanvraag) {
			return false;
		}

		// required lists not loaded? not ready yet...
		if (this.props.postcodes.length < 0 ||
			this.props.gemeenten.length < 0 ||
			this.props.juridischeStatuten.length < 0) {
			return false;
		}

		return true;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		return (
			<AanvraagForm
				color={types.COLOR_BLUE}
				aanvraag={this.state.aanvraag}
				disabled={this.props.disabled}
				errors={this.state.errors}
				listOfAanvragers={this.state.listOfAanvragers}
				postcodes={this.props.postcodes}
				gemeenten={this.props.gemeenten}
				juridischeStatuten={this.props.juridischeStatuten}
				onChange={this.handleOnChange}
				onChangeAanvrager={this.handleOnChangeAanvrager}
				onChangeContactpersoon={this.handleOnChangeContactpersoon}
				onAddAanvrager={this.handleOnAddAanvrager}
				onRemoveAanvrager={this.handleOnRemoveAanvrager}
				onAddGemandateerde={this.handleOnAddGemandateerde}
				onRemoveGemandateerde={this.handleOnRemoveGemandateerde}
				onChangeGemandateerde={this.handleOnChangeGemandateerde}
				onSave={this.handleOnSave}
			/>
		);
	}
}

// ----------------------------------------------------------------------------
AanvraagPage.propTypes = {
	typeAanvraagId: PropTypes.string.isRequired,
	aanvraagId: PropTypes.string.isRequired,
	aanvraag: PropTypes.object.isRequired,
	postcodes: PropTypes.array.isRequired,
	gemeenten: PropTypes.array.isRequired,
	juridischeStatuten: PropTypes.array.isRequired,
	saveAanvraag: PropTypes.func.isRequired,
	loadAanvraag: PropTypes.func.isRequired,
	loadEmptyAanvraag: PropTypes.func.isRequired,
	loadAanvraagFromSimulatie: PropTypes.func.isRequired,
	loadLayout: PropTypes.func.isRequired,
	getEmptyAanvrager: PropTypes.func.isRequired,
	getEmptyMandataris: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	const typeId = ownProps.params.type;
	const aanvraagId = ownProps.params.id;
	const simulatieId = ownProps.params.simulatieId;
	const infrastructuurId = state.infrastructuren[0] !== undefined ? state.infrastructuren[0].id : null;

	const isNew = !aanvraagId || !!simulatieId;

	const aanvraag = state.aanvraag;
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((aanvraag.item) && aanvraag.item.redenVanStatus == 121450000);
	return {
		isNewAanvraag: isNew,
		disabled: disabled,
		typeAanvraagId: typeId,
		aanvraag: aanvraag.item,
		aanvraagId: aanvraagId,
		simulatieId: simulatieId,
		errors: aanvraag.errors,
		validationMessageType: aanvraag.validationMessageType,
		postcodes: convertToLabelValuePair(state.referentie.postcodes),
		gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
		juridischeStatuten: convertToLabelValuePair(state.referentie.juridischeStatuten),
		infrastructuurId: infrastructuurId
	};
}

function mapDispatchToProps(dispatch) {
	return {
		saveAanvraag: bindActionCreators(aanvraagActions.saveAanvraag, dispatch),
		loadAanvraag: bindActionCreators(aanvraagActions.loadAanvraag, dispatch),
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch),
		loadEmptyAanvraag: bindActionCreators(aanvraagActions.loadEmptyAanvraag, dispatch),
		loadAanvraagFromSimulatie: bindActionCreators(aanvraagActions.loadAanvraagFromSimulatie, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadAanvraagPageLayout, dispatch),
		getEmptyAanvrager: bindActionCreators(aanvraagActions.getEmptyAanvrager, dispatch),
		getEmptyMandataris: bindActionCreators(aanvraagActions.getEmptyMandataris, dispatch),
		loadEmptyRenovatie: bindActionCreators(aanvraagActions.loadEmptyRenovatie, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(AanvraagPage));